import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Check, Lock, Play, Award } from "lucide-react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import TopNav from "@/components/TopNav";

export default function CourseDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [course, setCourse] = useState(null);

  const load = async () => { try { const { data } = await api.get(`/courses/${id}`); setCourse(data); } catch (e) { toast.error(apiErr(e)); nav("/courses"); } };
  useEffect(() => { load(); }, [id]);

  if (!course) return <div className="min-h-screen flex items-center justify-center text-teal-accent">Loading…</div>;
  const pct = Math.round((course.completed_days / 90) * 100);
  const complete = course.completed_days >= 90;

  return (
    <div className="min-h-screen">
      <TopNav />
      <main className="max-w-5xl mx-auto px-4 sm:px-8 pt-6 pb-24">
        <button data-testid="back-to-courses" onClick={() => nav("/courses")} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-teal-accent mb-6"><ArrowLeft size={16} /> All courses</button>
        <div className="glass-strong rounded-3xl p-7 mb-8">
          <h1 className="serif text-4xl font-extrabold">{course.title}</h1>
          <p className="text-muted-foreground mt-2 max-w-2xl">{course.description}</p>
          <div className="mt-5 flex items-center gap-4">
            <div className="flex-1 h-2 rounded-full bg-white/5 overflow-hidden"><div className="h-full bg-[#00D4D4]" style={{ width: `${pct}%` }} /></div>
            <span className="text-sm text-teal-accent font-medium">{course.completed_days}/90</span>
          </div>
          {complete && <div className="mt-4 flex items-center gap-2 text-teal-accent text-sm"><Award size={16} /> Course complete — certificate earned! Jobs unlocked.</div>}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {course.tasks.map((t) => (
            <button key={t.day} data-testid={`day-${t.day}`}
                    disabled={!t.unlocked}
                    onClick={() => nav(`/courses/${id}/day/${t.day}`)}
                    className={`glass rounded-2xl p-4 text-left transition-all ${t.unlocked ? "glass-hover" : "opacity-45 cursor-not-allowed"}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-muted-foreground">Day {t.day}</span>
                {t.completed ? <Check size={16} className="text-teal-accent" /> : t.unlocked ? <Play size={14} className="text-teal-accent" /> : <Lock size={14} className="text-muted-foreground" />}
              </div>
              <div className="text-sm font-medium line-clamp-2">{t.heading}</div>
            </button>
          ))}
        </div>
      </main>
    </div>
  );
}
